import React, { useEffect, useState } from 'react';
import BarStacked from './BarStacked';
import axiosInstance from '../../../core/axiosInstance';
import moment from 'moment';
import Spinner from '../../../components/Spinner/Spinner';

const Insights = () => {
  const [temps, setTemp] = useState([]);
  const [graphData, setGraphData] = useState();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [loading, setLoading] = useState(false);

  const [selectedTemps, setSelectedTemps] = useState<string | null>(null);
  const [show, setShow] = useState<boolean>(false);
  const [template_id, setTemplate_id] = useState<number | null>(null);
  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get('/dashboard/templates')
      .then((res: any) => {
        setTemp(res.data.data);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get('/dashboard/text-pages-stats')
      .then((res: any) => {
        console.log(res.data);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    setShow(true);
    console.log(startDate);

    setLoading(true);
    axiosInstance
      .get('/dashboard/text-pages-stats', {
        params: {
          start_date: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
          end_date: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
          template_id: template_id ? template_id : null,
        },
      })
      .then((res: any) => {
        setGraphData(res.data.data);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };
  const resetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedTemps(null);
    setTemplate_id(null);
    setShow(false);
  };
  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <BarStacked
          temps={temps}
          graphData={graphData}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          selectedTemps={selectedTemps}
          setSelectedTemps={setSelectedTemps}
          handleSubmit={handleSubmit}
          show={show}
          setTemplate_id={setTemplate_id}
          resetFilters={resetFilters}
        />
      )}
    </div>
  );
};

export default Insights;
